import { action, makeObservable, observable, runInAction } from 'mobx';
import { WebConfigurations, WebConfigurationsService } from 'us-web-services';

export class ConfigurationStore {
  configuration?: WebConfigurations = { featureFlags: {}, featureInfo: {} };
  version = 2;

  constructor() {
    makeObservable(this, {
      getConfiguration: action,
      configuration: observable,
    });

    this.getConfiguration(this.version);
  }

  async getConfiguration(version: number): Promise<void> {
    const response = (await WebConfigurationsService.get(version)).data;

    runInAction(() => {
      this.configuration = response.data;
    });
  }
}
